<template>
<div>
    <m-edit-text
            :label="label"
            :value="vcard_label"
            :custom_on_edit="() => {onClickEdit()}"
            :menu_items="menu_items"
            :hide_details="hide_details"
            v-on:clear="$emit('input',null)"
            :read_only="read_only"
        />

    <m-choose-vcard-dialog
        ref="edit-vcard-dialog"
        :title="dialog_title"
        :action_text="dialog_action_text"
        v-on:input="onSelectVCard"
    />

</div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return 'Select contact card'; }
        },

        dialog_title: {
            type: String, 
            default: function() { return 'Select contact card'; }
        },

        dialog_action_text: {
            type: String, 
            default: function() { return 'Use this contact card'; }
        },

        organization_id: {
            type: String, 
            default: function() { return null; }
        },

        endpoint: {
            type: String, 
            default: function() { return null; }
        },

        show_bulk_message_warning: {
            type: Boolean, 
            default: function() { return false; }
        },

        read_only: {
            type: Boolean, 
            default: function() { return false; }
        },

        hide_details: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            vcard_label: null,
            has_ack_contact_card_warning: false,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        onClickEdit() 
        {
            if ( this.has_ack_contact_card_warning || !this.show_bulk_message_warning)
            {
                this.doPickVCard();
            }
            else
            {
                this.$rc.confirm({
                 'title': 'Warning: Contact Cards in Bulk Messages',
                 'body': 'Sending a contact card with your bulk message will result in one <b>additional</b> MMS message being sent per recipient.<br/><br/>Also, the behavior of contact cards can very <b>significantly</b> from device to device.<br/><br/>Are you sure that you would like to attach a contact card?',
                 'btn_text_ok': 'Attach Contact Card',
                 'btn_text_cancel': 'Cancel',
                 'on_ok': () => {
                     this.has_ack_contact_card_warning = true;

                     this.doPickVCard();
                 },
             });
            }
        },

        doPickVCard()
        {
            let organization_id = this.organization_id;

            if ( organization_id == null )
                organization_id = this.$rc.$state.getOrganizationId();

            let search = {
                'organization_id': organization_id,
                'for_organization_owned_endpoint' : this.endpoint,
            };

            this.$refs['edit-vcard-dialog'].showDialog(search);
        },

        onSelectVCard(vcard)
        {
            if ( vcard == null ) return;
            this.$emit('input', vcard.vcard_id);
        },

        update()
        {
            if ( this.value == null )
            {
                this.vcard_label = null;
                return;
            }

            
            this.$rc.rest(
                'LIST: /api/v1/vcard',
            
                {
                    'vcard_id': this.value,
                },
            
                (data) => {
                    if ( data.results.length == 0 )
                    {
                        this.vcard_label = null;
                        return;
                    }
                    else
                    {
                        this.vcard_label = data.results[0].internal_label;
                    }
                },
            
                () => {
                    this.vcard_label = null;
                    return;
                },
            );
        },
    },

    computed: {
        menu_items() {
            if ( this.value == null ) return [];

            return [
              {
                'text': 'Select contact card...',
                'event': 'edit'
              },
              {
                'text': 'Clear',
                'event': 'clear'
              }  
            ];
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>